// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Function to reload product recommendations
function reloadProductRecommendations() {
  const productRecommendations = document.querySelector('cart-drawer product-recommendations') || 
                                document.querySelector('product-recommendations');
  
  if (!productRecommendations) return;
  
  const recommendations = productRecommendations.querySelector('[data-recommendations]');
  if (!recommendations) return;
  
  const datasetUrl = productRecommendations.dataset.url;
  if (!datasetUrl) return;
  
  fetch(datasetUrl)
    .then(response => response.text())
    .then(text => {
      const recommendationsHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('[data-recommendations]')?.innerHTML;
      
      if (!recommendationsHTML) return;
      
      productRecommendations.classList.remove('hidden');
      
      const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
      if (cartDrawerItemsFull) {
        cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
      }
      
      recommendations.innerHTML = recommendationsHTML;
      
      // Initialiser le slider si Swiper est disponible
      if (window.Swiper) {
        const swiperElement = productRecommendations.querySelector('.swiper');
        if (swiperElement) {
          new Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 16,
          });
        }
      }
      
      // Initialiser les formulaires et autres fonctionnalités
      setTimeout(() => {
        initRecommendationsForms(productRecommendations);
        
        if (document.querySelector("quick-cart-drawer")) {
          document.querySelector("quick-cart-drawer").init();
        } else {
          // Supprimer les boutons trigger si quick-cart-drawer n'existe pas
          productRecommendations.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
            el?.remove();
          });
        }
      }, 500);
    })
    .catch(error => {
      console.error('Erreur lors du rechargement des recommandations:', error);
    });
}

// Function to initialize recommendation forms
function initRecommendationsForms(productRecommendationsElement) {
  const addToCartForms = productRecommendationsElement.querySelectorAll('form.product-card__add-to-cart--form');
  
  if (addToCartForms.length > 0) {
    addToCartForms.forEach(form => {
      form.removeAttribute("method");
      form.removeAttribute("action");
      
      // Supprimer les anciens event listeners et en ajouter de nouveaux
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      newForm.addEventListener('submit', (event) => {
        handleRecommendationFormSubmit(event, productRecommendationsElement);
      });
    });
  }
}

// Function to handle recommendation form submit
function handleRecommendationFormSubmit(event, productRecommendationsElement) {
  event.preventDefault();

  const submitButton = event.target.querySelector('button[type="submit"]');
  if (submitButton) {
    submitButton.setAttribute("disabled", "");
    submitButton.classList.add("add-to-cart--is-disabled");
  }

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(event.target);
  
  // Get sections to render from cart drawer or cart items
  const cartDrawer = document.querySelector('cart-drawer');
  const cartItems = document.querySelector('cart-items');
  const sectionsSource = cartDrawer || cartItems;
  
  if (sectionsSource && sectionsSource.getSectionsToRender) {
    formData.append("sections", sectionsSource.getSectionsToRender().map(section => section.section));
  }
  formData.append("sections_url", window.location.pathname);

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.errors) {
        console.error('Erreur lors de l\'ajout au panier:', response.errors);
        return;
      }

      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(response);
      }
      updateCartCounters();
    })
    .catch((error) => { 
      console.error('Erreur lors de l\'ajout au panier:', error);
    })
    .finally(() => {
      if (submitButton) {
        submitButton.removeAttribute("disabled");
        submitButton.classList.remove("add-to-cart--is-disabled");
      }

      const quickCartDrawer = productRecommendationsElement.closest("quick-cart-drawer");
      if (quickCartDrawer) {
        quickCartDrawer.close();
      }
    });
}

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }

        });
        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();
        updateFreeShipping();
        reloadProductRecommendations();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());

    this.initSwym();
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(".product-recommendations");
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document.querySelector(".cart-drawer-items").classList.add("cart-drawer-items__full");
      } else {
        document.querySelector(".cart-drawer-items").classList.remove("cart-drawer-items__full");
      }
    }
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = 'auto';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });

    // Recharger les recommandations de produits
    reloadProductRecommendations();

    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }



  //Executed after SWYM has loaded all necessary resources.
  onSwymLoadCallback = (swat) => {
    // Please make all SWYM-related API calls inside this function.
    // You can use the swat argument within this scope.
    if (swat) {
      // Define eventname
      let event = 'sw:addedtocart';
      const cart = this;

      // Define the event listener function
      let listener = async function(e) { 
        var data = e.detail.d.productData;
        const section = {"id":"#CartDrawer-Body", "section":"cart-drawer", "selector":"#shopify-section-cart-drawer #CartDrawer-Body"};

        let section_html = await fetch(Shopify.routes.root + "?section_id=" + section.section)
        .then(response => response.text())
        .then(html => {
          return html;
        });

        section_html = cart.getSectionInnerHTML(section_html, section.selector);
       
        const sectionElement = document.querySelector(section.id);
        if (!sectionElement) return;
        sectionElement.innerHTML = section_html;
  
        updateCartCounters();
    
        // Hide SWYM drawer 
        const swymDrawer = document.querySelector("#swym-storefront-layout-container");
        if (swymDrawer) {
          swymDrawer.classList.add("swym-storefront-layout-hide-view");
        }
        
        cart.open();
      };

      // Add listener for the 'addedtocart' event to the Swym Event Layer
      swat.evtLayer.addEventListener(event, listener);
    }
  }

  initSwym() {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.onSwymLoadCallback);
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);